import React from 'react';
import {
  Route,
  Routes,
} from 'react-router-dom';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import Invoices from './Invoices';
import Products from './Products';

import UpgradeModal from './UpgradeModal';

const mapState = state => ({
  profile: coreSelectors.getProfile(state),
});

const BillingPage = () => {
  const { profile } = useSelector(mapState, shallowEqual);

  return process.env.TARGET_ENV !== 'development' && (profile.namespace === 'gymcloud' || !profile.stripe_user_id) ? (
    <>
      <Invoices isFake />
      <UpgradeModal />
    </>
  ) : (
    <Routes>
      <Route
        path="invoices"
        element={<Invoices />}
      />
      <Route
        path="products"
        element={<Products />}
      />
    </Routes>
  );
};

export default BillingPage;
